<template>

    <section id="MyActives" data-bs-theme="dark">
      <template v-if="!isBuyVisible && !isSaleVisible && !isDepositVisible && !isConcVisible">
        <div class="accordion mb-3" id="accordionExample" v-if="user?.active_operations?.length !== 0">
            <div class="accordion-item bg-transparent border_darkgreen">
              <h2 class="accordion-header o-text-primary u-font-weight-600">
                <button class="accordion-button flex-row shadow-none bg-transparent text-white o-text-primary u-font-weight-600 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#activeOperations" aria-expanded="true" aria-controls="activeOperations">
                    Активные операции
                </button>
              </h2>
              <div id="activeOperations" class="accordion-collapse bg-transparent collapse" data-bs-parent="#accordionExample">
                <div class="accordion-body text-white">
                 <!-- Продажа -->
                 <div v-for="(item, index) in filteredElementsSell" :key="'sell' + index">
                    <div class="p-3 p-md-2 ps-md-3 bg_green mb-2 rounded">
                            <div class="row">
                                <div class="col-12 col-sm-5">
                                    <span class="d-flex gap-2 align-items-center h-100">
                                        <span>{{ item?.payment_method?.payment_operation?.operation_group }}</span>
                                        <span class="ms-auto ms-sm-0">{{ ((parseFloat(item?.operation?.cryptocurrency_amount)) / (item?.payment_method?.currency_from.delimiter))?.toFixed(String(item?.payment_method?.currency_from?.delimiter).split('0').length - 1 || 0) }}</span>
                                        <span>{{ item?.payment_method?.currency_from?.code }}</span>
                                    </span>
                                </div>
                                <div class="col d-none d-md-block">
                                    <span class="text-end d-flex align-items-center h-100">
                                        {{ moment(item?.operation?.updated_at).format("H:mm") }}
                                    </span>
                                </div>
                                <div class="col d-none d-sm-block">
                                    <div class="gap-2 d-flex justify-content-end">
                                        <button class="btn btn-outline-danger px-4" @click="cancel(item?.operation?.id, 'payouts')">Отмена</button>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div class="row d-flex d-sm-none mb-3">
                        <div class="ms-auto col-6">
                            <button class="btn btn-lg btn-outline-danger px-4 w-100 mw-100" style="height: 48px" @click="cancel(item?.operation?.id, 'payouts')">Отмена</button>
                        </div>
                    </div>
                    </div>
        
                    <!-- Покупка -->
                    <div v-for="(item, index) in filteredElementsBuy" :key="'buy' + index">
                        <div class="p-3 p-md-2 ps-md-3 bg_green mb-2 rounded">
                            <div class="row">
                                <div class="col-12 col-sm-5">
                                    <span class="d-flex gap-2 align-items-center h-100">
                                        <span>{{ item?.payment_method?.payment_operation?.operation_group }}</span>
                                        <span class="ms-auto ms-sm-0">{{ ((parseFloat(item?.operation?.cryptocurrency_amount)) / (item?.payment_method?.currency_from.delimiter))?.toFixed(String(item?.payment_method?.currency_from?.delimiter).split('0').length - 1 || 0) }}</span>
                                        <span>{{ item?.payment_method?.currency_from?.code }}</span>
                                    </span>
                                </div>
                                <div class="col d-none d-md-block">
                                    <span class="text-end d-flex align-items-center h-100">
                                        {{ moment(item?.operation?.updated_at).format("H:mm") }}
                                    </span>
                                </div>
                                <div class="col d-none d-sm-block">
                                    <div class="gap-2 d-flex justify-content-end">
                                        <a target="_blank" :href="item?.operation?.link" class="d-flex align-items-center justify-content-center btn btn-outline-lightgreen px-4">Детали</a>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div class="row d-flex d-sm-none mb-3">
                        <div class="col-6 ms-auto">
                            <a target="_blank" :href="item?.operation?.link" class="d-flex align-items-center justify-content-center btn btn-lg btn-outline-lightgreen px-4 w-100 mw-100" style="height: 48px">Детали</a>
                        </div>
                    </div>
                    </div>
        
                    <!-- Депозит -->
                    <div v-for="(item, index) in filteredElementsDeposit" :key="'dep' + index">
                        <div class="p-3 p-md-2 ps-md-3 bg_green mb-2 rounded">
                            <div class="row">
                                <div class="col-12 col-sm-5">
                                    <span class="d-flex gap-2 align-items-center h-100">
                                        <span>{{ item?.payment_method?.payment_operation?.operation_group }}</span>
                                        <span class="ms-auto ms-sm-0">{{ ((parseFloat(item?.operation?.actual_amount || item?.operation?.proposed_amount)) / (item?.payment_method?.currency_from.delimiter))?.toFixed(String(item?.payment_method?.currency_from?.delimiter).split('0').length - 1 || 0) }}</span>
                                        <span>{{ item?.payment_method?.currency_from?.code }}</span>
                                    </span>
                                </div>
                                <div class="col d-none d-md-block">
                                    <span class="text-end d-flex align-items-center h-100">
                                        {{ moment(item?.operation?.updated_at).format("H:mm") }}
                                    </span>
                                </div>
                                <div class="col d-none d-sm-block">
                                    <div class="gap-2 d-flex justify-content-end">
                                        <button class="btn btn-outline-lightgreen px-4" @click="showDeposit(getCryptoByCode(item?.payment_method?.currency_from?.code), item?.operation)">Детали</button>
                                        <button class="btn btn-outline-danger px-4" @click="cancel(item?.operation?.id, 'deposits')">Отмена</button>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div class="row d-flex d-sm-none mb-3">
                        <div class="col-6">
                            <button class="btn btn-outline-lightgreen px-4 w-100 mw-100" style="height: 48px" @click="showDeposit(getCryptoByCode(item?.payment_method?.currency_from?.code), item?.operation)">Детали</button>
                        </div>
                        <div class="col-6">
                            <button class="btn btn-lg btn-outline-danger px-4 w-100 mw-100" style="height: 48px" @click="cancel(item?.operation?.id, 'deposits')">Отмена</button>
                        </div>
                    </div>
                    </div>
        
                    <!-- Вывод -->
                    <div v-for="(item, index) in filteredElementsConcl" :key="'concl' + index">
                        <div class="p-3 p-md-2 ps-md-3 bg_green mb-2 rounded">
                            <div class="row">
                                <div class="col-12 col-sm-5">
                                    <span class="d-flex gap-2 align-items-center h-100">
                                        <span>{{ item?.payment_method?.payment_operation?.operation_group }}</span>
                                        <span class="ms-auto ms-sm-0">{{ ((parseFloat(item?.operation?.cryptocurrency_amount)) / (item?.payment_method?.currency_from.delimiter))?.toFixed(String(item?.payment_method?.currency_from?.delimiter).split('0').length - 1 || 0) }}</span>
                                        <span>{{ item?.payment_method?.currency_from?.code }}</span>
                                    </span>
                                </div>
                                <div class="col d-none d-md-block">
                                    <span class="text-end d-flex align-items-center h-100">
                                        {{ moment(item?.operation?.updated_at).format("H:mm") }}
                                    </span>
                                </div>
                                <div class="col d-none d-sm-block">
                                    <div class="gap-2 d-flex justify-content-end">
                                        <button class="btn btn-outline-danger px-4" @click="cancel(item?.operation?.id, 'withdrawals')">Отмена</button>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div class="row d-flex d-sm-none mb-3">
                        <div class="ms-auto col-6">
                            <button class="btn btn-lg btn-outline-danger px-4 w-100 mw-100" style="height: 48px" @click="cancel(item?.operation?.id, 'withdrawals')">Отмена</button>
                        </div>
                    </div>
                    </div>
                </div>
              </div>
            </div>
        </div>


        <div class="accordion mb-3" :id="group.title+'-accordeon'" v-for="(group, index) in cryptoGroups" :key="index">
            <div class="accordion-item bg-transparent border-0">
              <h2 class="accordion-header o-text-primary u-font-weight-600">
                <button class="accordion-button p_mob_0 flex-row shadow-none bg-transparent text-white o-text-primary u-font-weight-600" type="button" data-bs-toggle="collapse" :data-bs-target="'#'+group.title+'acc'" aria-expanded="true" :aria-controls="group.title+'acc'">
                    {{ group.title }}
                </button>
              </h2>
              <div :id="group.title+'acc'" class="accordion-collapse bg-transparent collapse show" :data-bs-parent="'#'+group.title+'-accordeon'">
                <div class="accordion-body text-white p_mob_0">
                <div class="asset-grid">
                    <CryptoElementComponent
                      v-for="crypto in group.items"
                      :key="crypto.id"
                      :crypto="crypto"
                      @buy="buy"
                      @sale="sale"
                      @concl="concl"
                      @deposit="deposit"
                      @new_card="newCard"
                      @new_wallet="newWallet"
                      @showVerification="showModal"
                      :user="user"
                      :courses="courses"
                       @showBuy='showBuy'
                       @showDeposit='showDeposit'
                       @showConclusion='showConclusion'
                       @showSale='showSale'
                       :filteredElementsDeposit="filteredElementsDeposit"
                    />
                  </div>
                </div>
              </div>
            </div>
        </div>

      </template>
      <buy-crypto v-if='isBuyVisible' @new_card="newCard"
      @buy='buyTether' @close='closeBuy'
      :user="user" :cards="cards" :courses="courses" :crypto="crypto"
      :bank_list="bank_list" :currencies="currencies" :myMethods="myMethods" :balances="balances" />
  
        <sale-crypto @showVerification="showVerification" @showSale='showSale'
          v-if='isSaleVisible' @new_card="newCard" @sale="saleTether" @close='closeSale' :user="user"
          :cards="cards" :balance="myValue" :courses="courses" :crypto="crypto"
          :bank_list="bank_list" :currencies="currencies" :myMethods="myMethods" :balances="balances"
          />
  
        <deposit-crypto v-if='isDepositVisible' @deposit="deposit" @close='closeDeposit'
           :balance="myValue"
          :courses="courses" :crypto="crypto" :myMethods="myMethods" :course="course" :myCourse="myCourse" :actDep="actDep" />

        <conclusion-crypto @showVerification="showVerification" v-if='isConcVisible' @new_wallet="newWallet"
          @concl="conclTether" :user="user" @close='closeConclusion' :wallets="wallets" :balance="myValue"
          :courses="courses" :crypto="crypto" :myMethods="myMethods" />

        <add-wallet v-show='newWalletFlag' @close='closeAddWallet' :networks="networks" :cryptos="cryptos"/>
        <add-card v-show='newCardFlag' @close='closeAddCard'/>
    </section>

  </template>
  
<script>
import CryptoElementComponent from "@/components/Actives/CryptoElementComponent.vue";
import AppSpinner from "@/components/General/AppSpinner.vue";
import moment from "moment";
import BuyCrypto from '@/components/Actives/BuyCrypto.vue';
import SaleCrypto from '@/components/Actives/SaleCrypto.vue';
import ConclusionCrypto from "@/components/Actives/ConclusionCrypto.vue";
import DepositCrypto from "@/components/Actives/DepositCrypto.vue";
import AddWallet from "@/components/Wallets/AddWallet.vue";
import AddCard from "@/components/Cards/AddCard.vue";

  export default {
      props: [
          'courses',
          'user',
          'cards',
          'wallets',
          'cards_count',
          'wallets_count',
          'user_load',
          'cryptos',
          'balances',
          'for_buy',
          'for_deposit',
          'bank_list',
          'currencies'
      ],
      components: {
        CryptoElementComponent,
        AppSpinner,
        BuyCrypto,
        SaleCrypto,
        ConclusionCrypto,
        DepositCrypto,
        AddCard,
        AddWallet
      },
      data: () => ({
        isModalVisible: false,
        usdtAmount:0,
        btcAmount:0,
        loadTether: false,
        loadBitcoin: false,
        loadEthereum: false,
        loadToncoin: false,
        loadBinancecoin: false,
        loadLitecoin: false,
        newCardFlag: false,
        newWalletFlag: false,
        moment: moment,
        myMethods: [],
        isBuyVisible: false,
        isSaleVisible: false,
        isConcVisible: false,
        isDepositVisible: false,
        isOperVisible: false,
        crypto: {},
        networks: [],
        loading: false,
        actDep: []
      }),
    computed: {
        courses_BTC2USDT_rate() {
            return this.courses.find(c => (c.pair == 'BTC-USDT'))?.rate ?? 0;
        },
        cryptosWidthoutUSDT() {
            return this.cryptos.filter(c => c.currency.code !== 'USDT' && c.currency.code !== 'USDC')
                .sort((a, b) => a.currency.id - b.currency.id);
        },
        cryptosWithUSDT() {
            return this.cryptos.filter(c => c.currency.code === 'USDT' || c.currency.code === 'USDC')
                .sort((a, b) => a.currency.id - b.currency.id);
        },
        cryptoGroups() {
            return [
                { title: 'Стейблкоины', items: this.cryptosWithUSDT },
                { title: 'Криптоактивы', items: this.cryptosWidthoutUSDT }
            ];
        },
        myValue() {
            return (this.crypto.value / this.crypto?.currency?.delimiter) || 0;
        },
        myCourse() {
            return this.crypto?.currency?.code === 'USDT' ? 1 : this.course?.rate;
        },
        course() {
            return this.courses?.find(c => c.pair == `${this.crypto.currency?.code}-USDT`);
        },
        filteredElementsBuy() {
        return Array.isArray(this.user?.active_operations)
            ? this.user.active_operations
                .filter(o => o.payment_method?.payment_operation?.operation_group === 'Покупка')
                .sort((a, b) => b.id - a.id)
            : [];
        },
        filteredElementsSell() {
        return Array.isArray(this.user?.active_operations)
            ? this.user.active_operations
                .filter(o => o.payment_method?.payment_operation?.operation_group === 'Продажа')
                .sort((a, b) => b.id - a.id)
            : [];
        },
        filteredElementsDeposit() {
        return Array.isArray(this.user?.active_operations)
            ? this.user.active_operations
                .filter(o => o.payment_method?.payment_operation?.operation_group === 'Депозит')
                .sort((a, b) => b.id - a.id)
            : [];
        },

        filteredElementsConcl() {
            return Array.isArray(this.user?.active_operations)
                ? this.user.active_operations
                    .filter(o => o.payment_method?.payment_operation?.operation_group === 'Вывод')
                    .sort((a, b) => b.id - a.id)
                : [];
            },

        // activeDepCrypto() {
        //     return this.cryptoGroups.flatMap(group => group.items).find(item => item.currency.code === this.filteredElementsDeposit[0]?.payment_method?.currency_from?.code);
        // },
        },

      methods: {
        setErrors(response) {
            const errors = response?.data?.errors || {};
            const mess = response?.data?.message || 'Что-то пошло не так';
            let text = ''
            for (const field in errors) {
                text = errors[field][0];
                break;
            }
            eventBus.$emit('errorBus', text || mess);
        },
        getCryptoByCode(code) {
            return this.cryptoGroups.flatMap(group => group.items).find(item => item.currency.code === code);
        },
        closeAddWallet() {
            this.newWalletFlag = false;
            document.body.style.overflow = 'auto';
            this.$emit('close');
        },
        closeAddCard() {
            this.newCardFlag = false;
            document.body.style.overflow = 'auto';
            this.$emit('close');
        },
          buy(data) {
              this.$emit('buy', data);
          },
          sale(data) {
              this.$emit('sale', data);
          },
          concl(data) {
              this.$emit('concl', data);
          },
          deposit() {
              this.$emit('deposit');
          },
          closeModal() {
              this.isModalVisible = false;
              document.body.style.overflow = 'auto';
          },
          newCard() {
            this.newCardFlag = true;
          },
          newWallet() {
              this.newWalletFlag = true;
          },
          verify(){
                this.$emit('verify');
          },
          showModal() {
              if(this.$metrika !== undefined) {
                  this.$metrika.reachGoal('pop_up_verification');
              }
              this.isModalVisible = true;
              document.body.style.overflow = 'hidden';
          },
          closeModal() {
              this.isModalVisible = false;
              document.body.style.overflow = 'auto';
          },
          showVerification() {
            this.$emit('showVerification');
        },
        showOperations() {
            if (this.isOperVisible == true) {
                this.isOperVisible = false;
            } else {
                this.isOperVisible = true;
            }
        },
  
        buyTether(data) {
            this.$emit('buy', data);
        },
        saleTether(data) {
            this.$emit('sale', data);
        },
        conclTether(data) {
            this.$emit('concl', data);
        },
        deposit() {
            this.$emit('deposit');
            this.actDep.status = 'Подтвержден';
        },
        showBuy(crypto) {
            console.log('Покупка', crypto);
            this.crypto = crypto;
            if (this.$metrika !== undefined) {
                this.$metrika.reachGoal(this.crypto.currency?.code.toLowerCase() + '_buy');
            }
            this.isBuyVisible = true;
        },
        closeBuy() {
            this.isBuyVisible = false;
        },
        showSale(crypto) {
            this.crypto = crypto;
            if (this.$metrika !== undefined) {
                this.$metrika.reachGoal(this.crypto.currency?.code.toLowerCase() + '_sell');
            }
            this.isSaleVisible = true;
        },
        closeSale() {
            this.isSaleVisible = false;
        },
        showConclusion(crypto) {
            this.crypto = crypto;
            if (this.$metrika !== undefined) {
                this.$metrika.reachGoal(this.crypto.currency?.code.toLowerCase() + '_withdrawal');
            }
            this.isConcVisible = true;
        },
        closeConclusion() {
            this.isConcVisible = false;
        },
        showDeposit(crypto, actDep) {
            if(actDep) {
                this.actDep = actDep;
            }
            this.crypto = crypto;
            if (this.$metrika !== undefined) {
                this.$metrika.reachGoal(this.crypto.currency?.code.toLowerCase() + '_deposit');
            }
            this.isDepositVisible = true;
        },
        closeDeposit() {
            this.isDepositVisible = false;
            this.actDep = null;
        },

        cancel(id, address) {
            axios.delete(this.$api_address + `/operations/${address}/` + id, {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem('user_token')}`
                },
                data: { cancellation_message: 'Отмена пользователем' }
            }).then(response => {
                if(response.data.message) {
                    eventBus.$emit('errorBus', response.data.message);
                    return;
                }
                eventBus.$emit('errorBus', 'Операция успешно отменена', true);
            }).catch(error => {
                if (error.response?.status !== 401) {
                    this.setErrors(error.response);
                }
                else {
                    eventBus.$emit('logout');
                }
            });
        },

          async fetchMethods() {
              try {
                  const response = await axios.get(`${this.$api_address}/payment_methods/service/1`, {
                      headers: {
                          "Content-Type": "application/json",
                          "Accept": "application/json",
                          "Authorization": `Bearer ${localStorage.getItem('user_token')}`,
                      }
                  });

                  const actualData = response.data;
                  this.myMethods = actualData.data
                      .filter(item => item.active?.find(c => c.service?.name === "Valutix")?.active == 1)
                      .sort((a, b) => a.id - b.id);

              } catch (error) {
                  if (error.response?.status !== 401) {
                      eventBus.$emit('errorBus', 'Не удалось получить методы');
                  }
                  else {
                      eventBus.$emit('logout');
                  }
              }
          },
          async getNetworks() {
            try {
                const response = await axios.get(this.$api_address + "/wallets/cryptonetworks", {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem('user_token')}`,
                }
            });
                const actualData = response.data;
                this.networks = actualData.data;
            } catch (error) {
                if (error.response?.status !== 401) {
                    this.setErrors(error.response);
                } else {
                    eventBus.$emit('logout');
                }
            }
        },
    },
    watch: {
        cryptos: {
            immediate: true,
            handler(newCryptos) {
                if (newCryptos && newCryptos.length > 0) {
                    const { action, currency } = this.$route.query;
                    if (action && (currency == 'USDT' || currency == 'USDC')) {
                        const crypto = newCryptos.find(c => c.currency?.code === currency);
                        if (crypto) {
                            this.crypto = crypto;
                            if (action === 'buy') {
                                this.isBuyVisible = true;
                            } else if (action === 'sell') {
                                this.isSaleVisible = true;
                            }
                        }
                    }
                }
            }
        }
    },
      created() {
        this.fetchMethods();
        this.getNetworks();
      },
  }
</script>

<style scoped>
.accordion-button::after {
    filter: brightness(0) invert(1); /* делает chevron белым */
  }
  .lk__list p {
      font-size: 12px;
      font-family: Montserrat;
      Line-height: 17px;
  }
  .lk__list span {
      font-size: 15px;
  }

  .f14, .f14 span {
      font-size: 14px;
  }

  .f15, .f15 span {
      font-size: 15px;
  }
  .f17 .f17 span {
      font-size: 17px;
  }

  .no_min_height {
      min-height: unset !important;
  }

  .btn-outline-danger {
    color: #fff;
    background-color: #FF6D6D;
    font-size: 14px;
}

.btn-outline-lightgreen {
    color: #fff;
    background-color: #4AA485;
    font-size: 14px;
    border: none;
}

@media (max-width: 430px) {
    .p_mob_0 {
        padding-right: 0 !important;
        padding-left: 0 !important;
    }
}

</style>
